<template>
  <div class="ProgramActivityLevel-detail-page w-100">
    <b-form @submit.prevent="handleValidate">
      <basic-subheader>
        <template v-slot:actions>
          <b-button
            class="btn btn-light ml-3"
            type="button"
            @click="returnPage"
          >
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Arrows/arrow-left.svg" />
            </span>
            Huỷ
          </b-button>
          <b-button class="btn btn-light ml-3" type="button" @click="resetData">
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
            </span>
            Reset dữ liệu
          </b-button>
          <template>
            <b-button class="btn btn-success ml-3" @click.stop="handleValidate">
              <span class="svg-icon">
                <inline-svg
                  :src="`/media/svg/icons/Neolex/Basic/${
                    isCreateForm ? 'plus' : 'save'
                  }.svg`"
                />
              </span>
              {{ isCreateForm ? 'Tạo mới' : ' Cập nhật' }}
            </b-button>
          </template>
        </template>
      </basic-subheader>
      <b-overlay :show="loading">
        <b-container
          fluid
          class="ProgramActivityLevel-list-page__body mb-6 mt-6"
        >
          <b-row>
            <b-col>
              <div class="card card-custom gutter-b w-100">
                <div class="card-body mt-0">
                  <h5 class="card-title text-success">
                    Thông tin cấp độ hoạt động
                  </h5>
                  <b-row>
                    <b-col>
                      <b-row>
                        <b-col>
                          <basic-input
                            label="Mã"
                            placeholder="Mã"
                            name="code"
                            data-vv-as="Mã"
                            :required="true"
                            v-validate="'required'"
                            :value.sync="form.code"
                            :state="validateState('code')"
                            :invalidFeedback="
                              errors.first('code') || 'Vui lòng nhập mã'
                            "
                          ></basic-input>
                        </b-col>
                        <b-col>
                          <basic-select
                            label="Trạng thái hoạt động"
                            placeholder="Chọn trạng thái hoạt động"
                            name="isActive"
                            :options="isActives"
                            track-by="value"
                            value-label="name"
                            :value.sync="form.isActive"
                            @input="selected($event, 'isActive', isActives)"
                            data-vv-as="Trạng thái hoạt động"
                            :required="true"
                            v-validate="'required'"
                            :state="validateState('isActive')"
                            :invalidFeedback="
                              errors.first('isActive') ||
                              'Vui lòng chọn trạng thái hoạt động'
                            "
                          ></basic-select>
                        </b-col>
                        <b-col>
                          <basic-input
                            label="Tên cấp độ hoạt động"
                            placeholder="Ví dụ: Level 4"
                            name="name"
                            data-vv-as="Tên cấp độ hoạt động"
                            :required="true"
                            v-validate="'required'"
                            :value.sync="form.name"
                            :state="validateState('name')"
                            :invalidFeedback="errors.first('name')"
                          ></basic-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <basic-input
                            label="Thứ tự hiển thị"
                            placeholder="Thứ tự hiển thị"
                            name="displayIndex"
                            data-vv-as="Thứ tự hiển thị"
                            :required="true"
                            v-validate="'required|min_value:1'"
                            :value.sync="form.displayIndex"
                            :state="validateState('displayIndex')"
                            :invalidFeedback="errors.first('displayIndex')"
                          ></basic-input>
                        </b-col>
                        <b-col>
                          <basic-input
                            label="Ghi chú"
                            placeholder="Ghi chú"
                            name="note"
                            data-vv-as="Ghi chú"
                            :required="true"
                            v-validate="'required'"
                            :value.sync="form.note"
                            :state="validateState('note')"
                            :invalidFeedback="errors.first('note')"
                          ></basic-input>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
                <div
                  class="card-footer d-flex align-items-lg-center justify-content-center"
                >
                  <b-button
                    class="btn btn-light ml-3"
                    type="button"
                    @click.stop="resetData"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                      />
                    </span>
                    Reset dữ liệu
                  </b-button>
                  <b-button
                    class="btn btn-success ml-3"
                    @click.stop="handleValidate"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        :src="`/media/svg/icons/Neolex/Basic/${
                          isCreateForm ? 'plus' : 'save'
                        }.svg`"
                      />
                    </span>
                    {{ isCreateForm ? 'Tạo mới' : 'Cập nhật' }}
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-overlay>
    </b-form>
  </div>
</template>

<script>
import 'vue2-datepicker/index.css';
export default {
  components: {},
  props: {
    id: {
      type: String,
      default: null,
    },
    form_type: {
      type: String,
      default: 'edit',
    },
  },
  data() {
    return {
      isActives: [
        {
          name: 'Hoạt động',
          value: 1,
        },
        {
          name: 'Không hoạt động',
          value: 0,
        },
      ],
      form: {},
      file: null,
      preview: null,
      loading: false,
    };
  },
  created() {
    this.initDataInSelect();
    this.loadProgramActivityLevelData();

    this.$validator.extend('positiveNumber', {
      getMessage: (field) => `${field} phải là một số nguyên dương lớn hơn 0.`,
      validate: (value) => {
        const num = parseInt(value);
        return !isNaN(num) && num > 0;
      },
    });
  },
  computed: {
    nationId() {
      return this.form.nation?.id;
    },
    provinceId() {
      return this.form.province?.id;
    },
    districtId() {
      return this.form.district?.id;
    },
    isCreateForm() {
      return this.form_type === 'create' || this.form_type === 'copy';
    },
  },
  methods: {
    selected(value, formProperty, optionsArr) {
      this.form[formProperty] =
        optionsArr.find((el) => el.value === value) || null;
      if (this.form[formProperty] || this.form[formProperty]?.value === 0) {
        this.$validator.reset({ name: formProperty });
        this.$validator.errors.remove(formProperty);
        this.$validator.validate(formProperty);
      }
    },
    resetData() {
      this.form.code = null;
      this.form.isActive = null;
      this.form.name = null;
      this.form.displayIndex = null;
      this.form.note = null;
      this.$validator.reset();
      this.$validator.errors.clear();
    },
    async initDataInSelect() {
      try {
        this.loading = true;
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.loading = false;
      }
    },
    mapDataSelect(response) {
      return response?.data.items.map((value) => {
        return {
          id: value?.id,
          text: value?.name ?? value?.description,
        };
      });
    },
    clear() {
      this.preview = null;
    },
    notBeforeToday(date) {
      return date > new Date();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    async returnPage() {
      (await this.handleConfirm())
        ? this.$router.push({
            name: 'program_activity_level_list',
          })
        : null;
    },
    async handleConfirm() {
      let confirm = await this.$swal({
        text: 'Các thay đổi sẽ không được lưu trữ, bạn có chắc muốn huỷ?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Huỷ',
            value: true,
            visible: true,
            className: 'btn-warning',
            closeModal: true,
          },
        },
      });
      return confirm;
    },
    async handleValidate() {
      await this.$validator.validateAll();
      if (this.errors.any()) {
        return;
      } else {
        this.submit();
      }
    },
    async submit() {
      let payload = new FormData();
      const isCreateForm = this.isCreateForm;
      this.form.code && payload.append('code', this.form.code);
      this.form.isActive &&
        payload.append(
          'isActive',
          typeof this.form.isActive === 'object'
            ? this.form.isActive.value
            : this.form.isActive,
        );
      this.form.name && payload.append('name', this.form.name);
      this.form.displayIndex &&
        payload.append('displayIndex', this.form.displayIndex);
      this.form.note && payload.append('note', this.form.note);

      let confirm = await this.$swal({
        text: `${
          isCreateForm
            ? 'Bạn có chắc muốn tạo cấp độ hoạt động mới này không? '
            : 'Bạn có chắc muốn cập nhật thông tin cấp độ hoạt động này hay không?'
        }`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: 'btn-success',
            closeModal: true,
          },
        },
      });
      if (confirm) {
        if (isCreateForm) {
          this.handleCreate(payload);
        } else {
          this.handleUpdate(payload);
        }
      }
    },
    async handleCreate(payload) {
      try {
        this.loading = true;
        await this.$api.post(`ProgramActivityLevel`, payload);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Chúc mừng, Cấp độ hoạt động mới đã được tạo!',
        });
        this.$router.push({ name: 'program_activity_level_list' });
      } catch (e) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Vui lòng kiểm tra lại dữ liệu, tên cấp độ hoạt động không được trùng!',
        });
      } finally {
        this.loading = false;
      }
    },
    async handleUpdate(payload) {
      payload.append('id', this.form.id);
      try {
        this.loading = true;
        const id = this.form.id;
        await this.$api.put(`ProgramActivityLevel/${id}`, payload);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Chúc mừng, Cấp độ hoạt động đã được cập nhật!',
        });
        this.$router.push({ name: 'program_activity_level_list' });
      } catch (e) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Vui lòng kiểm tra lại dữ liệu, tên cấp độ hoạt động không được trùng!',
        });
      } finally {
        this.loading = false;
      }
    },
    async loadProgramActivityLevelData() {
      if (!this.$route.params.id) return;
      try {
        this.loading = true;
        const id = this.$route.params.id;
        let { data } = await this.$api.get(`ProgramActivityLevel/${id}`);
        this.form = data;
        this.form.isActive =
          this.isActives.find((item) => item.value === data.isActive) || null;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pictureInput {
  position: relative;
}
.icon-edit {
  z-index: 100;
  position: absolute;
  top: -15px;
  right: -6px;
  padding: 2px 6px;
  box-shadow: -1px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  width: fit-content;
  background-color: #fff;
}
.aterisk {
  color: #f64e60;
  font-size: 0.9rem;
}
</style>
